import pkg from "../../package.json"

export const getProjectVersion = function () {
  return pkg.version
}

const printProjectVersion = function () {
  const version = getProjectVersion()
  /* eslint-disable */
  console.log("running haytek react-front on version:", version)
  return version
}

export default printProjectVersion
